import { useSyncExternalStore } from "react";

// One shared minute tick for every clock on the page.
const listeners = new Set<() => void>();
let timer: ReturnType<typeof setTimeout> | null = null;

function schedule(): void {
  timer = setTimeout(() => {
    for (const listener of listeners) listener();
    schedule();
  }, 60_000 - (Date.now() % 60_000) + 50);
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  if (!timer) schedule();
  return () => {
    listeners.delete(listener);
    if (!listeners.size && timer) { clearTimeout(timer); timer = null; }
  };
}

const currentMinute = () => Math.floor(Date.now() / 60_000);

/** Minutes since the epoch; re-renders on each minute boundary. */
export function useMinute(): number {
  return useSyncExternalStore(subscribe, currentMinute, currentMinute);
}
